export default "__VITE_ASSET__qaVDAj69__"